import React from 'react';

import { State as AppState } from '../../App';

interface Props {
  detectorName: 'autocorrelation' | 'mcleod';
  windowSize: number;
  clarityThreshold: number;
  displayType: 'chart' | 'circle';
  onParamChange: <K extends keyof AppState>(key: K, value: AppState[K]) => void;
}

const Loader: React.FC<Props> = ({
  detectorName,
  windowSize,
  clarityThreshold,
  displayType,
  onParamChange,
}) => {
  return (
    <React.Fragment>
      <div className="content" style={{ textAlign: 'center' }}>
        <h2>A Rust + WebAssembly Pitch Detector</h2>
        <h3>Author</h3>
        <span>Alessandro Genova</span>
        <h3>Core Library</h3>
        <span>
          <a
            href="https://github.com/alesgenova/pitch-detection"
            target="_blank"
          >
            Source
          </a>
          <br />
          (rust)
        </span>
        <h3>Demo App</h3>
        <span>
          <a
            href="https://github.com/alesgenova/pitch-detection-app"
            target="_blank"
          >
            Source
          </a>
          <br />
          (wasm, react)
        </span>
        <br />
        <h3>Detector</h3>
        <select
          value={detectorName}
          onChange={(e) => {
            onParamChange('detectorName', e.target.value as any);
          }}
        >
          <option value="mcleod">McLeod</option>
          <option value="autocorrelation">Autocorrelation</option>
        </select>
        <h3>Window Size</h3>
        <select
          value={windowSize}
          onChange={(e) => {
            onParamChange('windowSize', parseInt(e.target.value));
          }}
        >
          <option value={512}>512 samples</option>
          <option value={1024}>1024 samples</option>
          <option value={2048}>2048 samples</option>
          <option value={4096}>4096 samples</option>
        </select>
        <h3>Clarity Threshold</h3>
        <input
          value={clarityThreshold}
          type="range"
          min={0.0}
          max={1.0}
          step={0.01}
          onChange={(e) => {
            onParamChange('clarityThreshold', parseFloat(e.target.value));
          }}
        />
        <br />({clarityThreshold})<h3>Display Type</h3>
        <select
          value={displayType}
          onChange={(e) => {
            onParamChange('displayType', e.target.value as 'chart' | 'circle');
          }}
        >
          <option value="chart">Linear Chart</option>
          <option value="circle">Circle Chart</option>
        </select>
      </div>
    </React.Fragment>
  );
};

export default Loader;
